import styles from '../cssModules/index.module.css';
import { useState } from "react";
import { useNavigate } from "react-router-dom";


export function SareeRepeat({ prod, setProdInfo, loginStatus }) {

    const apiURL = process.env.REACT_APP_SELLER;
    let jToken = localStorage.getItem('token');

    const fabric = ['Cotton', 'Denim', 'Fleece', 'Rayol', 'Chiffon', 'Wool', 'Art silk',
        'Corduroy', 'Crepe', 'Down', 'Faux Fur', 'Fur', 'Georgette', 'Lenin', 'Modal',
        'Rayon', 'Satin', 'Silk', 'Synthetic', 'Velvet', 'Net'
    ];
    const color = ['red', 'green', 'blue', 'grey', 'white', 'black', 'brown', 'pink', 'orange', 'yellow', 'purple', 'gold', 'silver',
        'turquoise', 'whitesmoke'];

    // const userSegment = ['Men', 'Women'];

    const style = ['Lehenga Saree', 'Ready Pleated Saree', 'With Blouse Piece',
        'Without Blouse Piece'
    ]

    const ethnicWeave = ['Baluchari', 'Banarasi', 'Bhagalpuri', 'Chanderi', 'Chettinad',
        'Gadwaal', 'Jaal', 'Jamdani', 'Kanchipuram', 'Kasavu', 'Khadi', 'Khes', 'Kota Doria',
        'Maheshwari', 'Narayanpet', 'Paithani', 'Pashmina', 'Patola', 'Sambalpuri',
        'Tant', 'Venkatagiri'
    ]

    const ethnicDesign = ['Bandhej', 'Ikat', 'Kalamkari', 'Leheriya', 'Self Print']

    const careInstruction = ['Machine Wash', 'Hand Wash Only', 'Dry Clean Only']

    const design = ['Solid', 'Striped', 'Graphic', 'Cartoon', 'Animal print', 'Argyle', 'Camouflage',
        'Chequered', 'Floral', 'Galaxy', 'Geometric', 'Hearts', 'Herringbone', 'Letter Print',
        'Paisley', 'Plaid', 'Polka Dots', 'Chevron', 'Fruits', 'Houndstooth', 'Letter print',
        'Stars'
    ]

    
    const stock = ['In stock', 'Out of stock']

    const weightCat = ['Category 1 (upto 500 gm)', 'Category 2 (between 500 gm to 1 kg)', 'Category 3 (between 1 to 2 kg)']

    const [pht1, setpht1] = useState();
    const [pht2, setpht2] = useState();
    const [pht3, setpht3] = useState();
    const [pht4, setpht4] = useState();
    const [pht5, setpht5] = useState();

    const navigate = useNavigate();

    function checkFileSize(file) {
        if (file.size > 500000) {
            alert('File size should be less than 500 KB');
            return false;
        } else {
            return true;
        }
    }

    const ph1Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht1(e.target.files[0]);
    }
    const ph2Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht2(e.target.files[0]);
    }
    const ph3Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht3(e.target.files[0]);
    }
    const ph4Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht4(e.target.files[0]);
    }
    const ph5Upload = (e) => {
        if (!checkFileSize(e.target.files[0])) {
            e.target.value = '';
        };
        setpht5(e.target.files[0]);
    }

    function changeWeightCat(value) {
        switch (true) {
            case (value === 'Category 1 (upto 500 gm)'):
                return 1;
            case (value === 'Category 2 (between 500 gm to 1 kg)'):
                return 2;
            default:
                return 3;
        }
    }

    function changeWeightCatReverse(value) {
        switch (true) {
            case (Number(value) === 1):
                return 'Category 1 (upto 500 gm)';
            case ((Number(value)) === 2):
                return 'Category 2 (between 500 gm to 1 kg)';
            default:
                return 'Category 3 (between 1 to 2 kg)';
        }
    }

    const handleSubmit = async (e, msg) => {
        try {
            e.preventDefault();
            const images = [pht1, pht2, pht3, pht4, pht5];
            if (!(pht1 && pht2 && pht3 && pht4 && pht5)) return;

            const formData = new FormData();
            images.forEach((image) => {
                formData.append('images', image);
            });
            formData.append('product', JSON.stringify(prod));

            const response = await fetch(`${apiURL}/api/upload/image`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${jToken}` },
                body: formData,
                credentials: 'include'
            })

            if (response.status === 500) {
                throw new Error('Error while uploading product!');
            } else {

                if (response.status === 200) {
                    if (msg === 'repeat') {
                        // let data = await response.json();
                        // let prodId = data['prodId'];
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    } else {
                        alert('Product has been listed successfully!');
                        window.location.reload();
                    }
                } else {
                    navigate('/error');
                }
            }
        } catch (error) {
            console.log(error.message);
            await loginStatus();
            navigate('/login');
        }
    }

    // const toggleSelection = (value, name) => {
    //     try {
    //         let newArr;
    //         if (prod[name]['size'].includes(value)) {
    //             newArr = prod[name]['size'].filter((v) => v !== value)
    //         } else {
    //             newArr = [...prod[name]['size'], value]
    //         }

    //         setProdInfo(prev => {
    //             return { ...prev, [name]: { 'size': newArr } }
    //         })

    //     } catch (error) {
    //         console.log(error.message);
    //     }
    // };

    return (
        <>
            <div className={`${styles.sellerUploadmainDiv}`}>
                <form id='uploadForm' onSubmit={(e) => handleSubmit(e, 'form')} className={`${styles.sellerUploadForm}`}>
                    <div className={`${styles.sellerUploadDiv}`}>
                        <div className={`${styles.sellerUploadPhotoSecDiv}`}>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph1'>
                                    Choose photo 1
                                </label>
                                <input id='ph1' type='file' onChange={ph1Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph2'>
                                    Choose photo 2
                                </label>
                                <input id='ph2' type='file' onChange={ph2Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph3'>
                                    Choose photo 3
                                </label>
                                <input id='ph3' type='file' onChange={ph3Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph4'>
                                    Choose photo 4
                                </label>
                                <input id='ph4' type='file' onChange={ph4Upload} required={true} accept='image/*' />
                            </div>
                            <div className={`${styles.sellerUploadPhotoInput}`}>

                                <label for='ph5'>
                                    Choose photo 5
                                </label>
                                <input id='ph5' type='file' onChange={ph5Upload} required={true} accept='image/*' />
                            </div>
                        </div>
                        <div className={`${styles.selleruploadFormDiv}`}>
                            {/* Later I will have to modify this in such a way that,
                                        when user select different product,
                                        their form will be different */}

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='fabric'>
                                    Fabric
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='fabric' name='fabric' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.fabric} selected hidden>{prod.fabric}</option>
                                    {fabric.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='color'>
                                    Color
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='color' name='color' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.color} selected hidden>{prod.color}</option>
                                    {color.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='style'>
                                    Style
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='style' name='style' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required form="uploadForm">
                                    <option value={prod.style} selected hidden>{prod.style}</option>
                                    {style.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='ethnicWeave'>
                                    Ethnic weave
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='ethnicWeave' required name='ethnicWeave' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.ethnicWeave} selected hidden>{prod.ethnicWeave}</option>
                                    {ethnicWeave.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='ethnicDesign'>
                                    Ethnic design
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='ethnicDesign' required name='ethnicDesign' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.ethnicDesign} selected hidden>{prod.ethnicDesign}</option>
                                    {ethnicDesign.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            {/* <div className={`${styles.sellerUploadLabelDiv}`}>
            
                                            <label for='specialFeature'>
                                            Special feature
                                            </label>
                                            <select className={`${styles.sellerUploadSelect}`} id='specialFeature' required name='specialFeature' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                                <option value='' selected hidden></option>
                                                {size.map(item => {
                                                    return (
                                                        <>
                                                            <option value={item}>{item}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                        </div> */}

                            {/* <div className={`${styles.sellerUploadLabelDiv}`}>
            
                                            <label for='closureType'>
                                            Closure type
                                            </label>
                                            <select className={`${styles.sellerUploadSelect}`} id='closureType' required name='closureType' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                                <option value='' selected hidden></option>
                                                {size.map(item => {
                                                    return (
                                                        <>
                                                            <option value={item}>{item}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                        </div> */}

                            {/* <div className={`${styles.sellerUploadLabelDiv}`}>
            
                                            <label for='pocketDescription'>
                                            Pocket description
                                            </label>
                                            <select className={`${styles.sellerUploadSelect}`} id='pocketDescription' required name='pocketDescription' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                                <option value='' selected hidden></option>
                                                {size.map(item => {
                                                    return (
                                                        <>
                                                            <option value={item}>{item}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                        </div> */}

                            {/* <div className={`${styles.sellerUploadLabelDiv}`}>
            
                                            <label for='sleeveCuffStyle'>
                                            Sleeve cuff style
                                            </label>
                                            <select className={`${styles.sellerUploadSelect}`} id='sleeveCuffStyle' required name='sleeveCuffStyle' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                                <option value='' selected hidden></option>
                                                {size.map(item => {
                                                    return (
                                                        <>
                                                            <option value={item}>{item}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                        </div> */}

                            {/* <div className={`${styles.sellerUploadLabelDiv}`}>
            
                                            <label for='neckLine'>
                                            Neck line
                                            </label>
                                            <select className={`${styles.sellerUploadSelect}`} id='neckLine' required name='neckLine' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                                <option value='' selected hidden></option>
                                                {size.map(item => {
                                                    return (
                                                        <>
                                                            <option value={item}>{item}</option>
                                                        </>
                                                    )
                                                })}
                                            </select>
                                        </div> */}

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='careInstruction'>
                                    Care instruction
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='careInstruction' required name='careInstruction' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.careInstruction} selected hidden>{prod.careInstruction}</option>
                                    {careInstruction.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='design'>
                                    Design
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='design' required name='design' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.design} selected hidden>{prod.design}</option>
                                    {design.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>


                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='stock'>
                                    Stock
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='stock' required name='active' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.active} selected hidden>{prod.active}</option>
                                    {stock.map(item => {
                                        return (
                                            <>
                                                <option value={item}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>

                                <label for='weightCat'>
                                    Weight category (Courier ready)
                                </label>
                                <select className={`${styles.sellerUploadSelect}`} id='weightCat' required name='weightCat' onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} form="uploadForm">
                                    <option value={prod.weightCat} selected hidden>{changeWeightCatReverse(prod.weightCat)}</option>
                                    {weightCat.map(item => {
                                        return (
                                            <>
                                                <option value={changeWeightCat(item)}>{item}</option>
                                            </>
                                        )
                                    })}
                                </select>
                            </div>

                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='name'>
                                    Name
                                </label>
                                <input className={`${styles.sellerUploadSelect}`}
                                    id='name'
                                    defaultValue={prod.name}
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })} required={true} type='text' placeholder="Name of the product" name='name' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='price'>
                                    Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`}
                                    id='price'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    defaultValue={prod.oldPrice}
                                    required={true} type='number' placeholder="price" name='oldPrice' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='discountP'>
                                    Discount Price
                                </label>
                                <input className={`${styles.sellerUploadSelect}`}
                                    id='discountP'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    defaultValue={prod.currentPrice}
                                    required={true} type='number' placeholder="This price will be highlighted" name='currentPrice' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='stock'>
                                    In stock
                                </label>
                                <input
                                    className={`${styles.sellerUploadSelect}`}
                                    id='stock'
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    defaultValue={prod.stock}
                                    required={true} type='number' placeholder="Total stock available" name='stock' />
                            </div>
                            <div className={`${styles.sellerUploadLabelDiv}`}>
                                <label for='sku'>
                                    Stock keeping unit
                                </label>
                                <input className={`${styles.sellerUploadSelect}`} id='sku' defaultValue={prod.sku}
                                    onChange={(e) => setProdInfo(prev => { return ({ ...prev, [e.target.name]: e.target.value }) })}
                                    required={true}
                                    type='text'
                                    placeholder="SKU"
                                    name='sku' />
                            </div>
                        </div>
                    </div>
                    <input type="submit" value='UPLOAD' className={`${styles.sellerUploadBtn}`} />
                    <button className={`${styles.uploadRepeat}`}
                        onClick={(e) => { handleSubmit(e, 'repeat') }}>Upload & Repeat</button>
                </form >
            </div >
        </>
    )
}